import React from 'react';

import { ArrivalStep } from './ArrivalStep/ArrivalStep';
import { ContactDetailsStep } from './ContactDetailsStep/ContactDetailsStep';
import { PaymentStepWrapper } from './PaymentStep/PaymentStepWrapper';
import { PricingFormStep } from './PricingFormStep/PricingFormStep';
import { TroubleShootingMergeStep } from './TroubleShootingStep/TroubleShootingMergeStep';
import { CategoryStep } from './CategoryStep';
import { ConfirmBookingStep } from './ConfirmBookingStep';
import { ServiceDetailsStep } from './ServiceDetailsStep';
import { ServiceStep } from './ServiceStep';
import { SubCategoryStep } from './SubCategoryStep';

export type StepNames = [
  'categories',
  'sub-categories',
  'services-troubleshooting',
  'service-details',
  'pricing-form',
  'services',
  'contact-details',
  'booking',
  'confirmation',
  'payment',
];

export const FIRST_STEP_KEY = 'categories';

export type StepHashMap = {
  [key in StepNames[number]]: {
    component: ((<P extends Record<string, unknown>>(props: P) => JSX.Element) | React.FunctionComponent) & {
      hiddenButtons?: boolean;
    };
    name: StepNames[number];
  };
};

export const STEP_HASH_MAP: StepHashMap = {
  categories: {
    component: CategoryStep,
    name: 'categories',
  },
  'sub-categories': {
    component: SubCategoryStep,
    name: 'sub-categories',
  },
  services: {
    component: ServiceStep,
    name: 'services',
  },
  'service-details': {
    component: ServiceDetailsStep,
    name: 'service-details',
  },
  'pricing-form': {
    component: PricingFormStep,
    name: 'pricing-form',
  },
  'services-troubleshooting': {
    component: TroubleShootingMergeStep,
    name: 'services-troubleshooting',
  },
  'contact-details': {
    component: ContactDetailsStep,
    name: 'contact-details',
  },
  booking: {
    component: ArrivalStep,
    name: 'booking',
  },
  confirmation: {
    component: ConfirmBookingStep,
    name: 'confirmation',
  },
  payment: {
    component: PaymentStepWrapper,
    name: 'payment',
  },
};
